import { Box, Skeleton, Container } from '@mui/material';

export const LandingPageSkeleton = () => {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'white' }}>
      {/* Hero Section Skeleton */}
      <Box
        sx={{
          py: { xs: 8, md: 12 },
          bgcolor: 'grey.50',
        }}
      >
        <Container maxWidth="md">
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            {/* Avatar */}
            <Skeleton
              variant="circular"
              width={120}
              height={120}
              sx={{ mb: 3 }}
            />

            {/* Name */}
            <Skeleton
              variant="text"
              width={180}
              height={32}
              sx={{ mb: 2 }}
            />

            {/* Headline */}
            <Skeleton
              variant="text"
              width="80%"
              height={60}
              sx={{ mb: 1 }}
            />
            <Skeleton
              variant="text"
              width="60%"
              height={60}
              sx={{ mb: 2 }}
            />

            {/* Subheadline */}
            <Skeleton
              variant="text"
              width="90%"
              height={28}
              sx={{ mb: 1 }}
            />
            <Skeleton
              variant="text"
              width="70%"
              height={28}
              sx={{ mb: 4 }}
            />

            {/* CTA Button */}
            <Skeleton
              variant="rounded"
              width={240}
              height={48}
              sx={{ borderRadius: 2 }}
            />
          </Box>
        </Container>
      </Box>

      {/* About Section Skeleton */}
      <Box sx={{ py: { xs: 6, md: 8 } }}>
        <Container maxWidth="md">
          <Skeleton
            variant="text"
            width={150}
            height={40}
            sx={{ mx: 'auto', mb: 3 }}
          />
          <Skeleton variant="text" width="100%" height={24} />
          <Skeleton variant="text" width="100%" height={24} />
          <Skeleton variant="text" width="80%" height={24} />
        </Container>
      </Box>

      {/* Services Section Skeleton */}
      <Box sx={{ py: { xs: 6, md: 8 }, bgcolor: 'grey.50' }}>
        <Container maxWidth="lg">
          <Skeleton
            variant="text"
            width={120}
            height={40}
            sx={{ mx: 'auto', mb: 4 }}
          />
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: '1fr 1fr 1fr' },
              gap: 3,
            }}
          >
            {[1, 2, 3].map((i) => (
              <Skeleton
                key={i}
                variant="rounded"
                height={200}
                sx={{ borderRadius: 2 }}
              />
            ))}
          </Box>
        </Container>
      </Box>

      {/* Lead Magnet Section Skeleton */}
      <Box sx={{ py: { xs: 8, md: 10 } }}>
        <Container maxWidth="sm">
          <Skeleton
            variant="text"
            width="80%"
            height={48}
            sx={{ mx: 'auto', mb: 2 }}
          />
          <Skeleton
            variant="text"
            width="60%"
            height={28}
            sx={{ mx: 'auto', mb: 4 }}
          />
          <Skeleton
            variant="rounded"
            height={400}
            sx={{ borderRadius: 2 }}
          />
        </Container>
      </Box>
    </Box>
  );
};
